import axios from './axiosConfig';
import {postHttp, getHttp} from './service';

/** fxzapi 接口前缀 — 用户、AI工具、公告等管理接口 */
export const FXZ_API_URI_PREFIX = '/fg-ai-center/fxzapi';
/** newapi 接口前缀 — 渠道模型、Token 用量统计等接口 */
export const NEWAPI_API_URI_PREFIX = '/fg-ai-center/newapi';
/** luoshu 接口前缀 */
export const LUOSHU_API_URI_PREFIX = '/fg-ai-center/luoshu';
/** dify 接口前缀 */
export const DIFY_API_URI_PREFIX = '/fg-ai-center/req-dify';
/** lingma 接口前缀 */
export const LINGMA_API_URI_PREFIX = '/fg-ai-center/lingma';
/** 模型监控接口前缀 */
export const MODEL_MONITOR_API_URI_PREFIX = '/fg-ai-center/llm-monitor/api';

//获取token
export function getAuthTokenApi(params,cb){
    postHttp(FXZ_API_URI_PREFIX,'/user/get_auth_token',params,cb);
}

